import jQuery from "jquery";
import { Spinner } from "spin.js";

export default function initZlickMobilePayment() {
  const isPresent = document.querySelectorAll("#zlick-donation-amount-form");

  if (!isPresent.length) {
    return;
  }

  ("use strict");

  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(
              function (value) {
                step("next", value);
              },
              function (err) {
                step("throw", err);
              }
            );
          }
        }
        return step("next");
      });
    };
  }

  (function ($) {
    /* Zlick function to initialize zlick - checks if the user is new or returning by saving the userId */
    var initZlick = (function () {
      var _ref = _asyncToGenerator(
        /*#__PURE__*/ regeneratorRuntime.mark(function _callee(token) {
          var response;
          return regeneratorRuntime.wrap(
            function _callee$(_context) {
              while (1) {
                switch ((_context.prev = _context.next)) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return zlick.identifyClient(token);

                  case 3:
                    response = _context.sent;

                    userId = response.userId;
                    contentId = response.contentId;
                    _context.next = 11;
                    break;

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);

                    console.log(_context.t0);

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            },
            _callee,
            this,
            [[0, 8]]
          );
        })
      );

      return function initZlick(_x) {
        return _ref.apply(this, arguments);
      };
    })();

    /* Zlick function to handle sending SMS pin code */

    var sendPinCodeSMS = (function () {
      var _ref2 = _asyncToGenerator(
        /*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
          var mobilePhoneNumber, response;
          return regeneratorRuntime.wrap(
            function _callee2$(_context2) {
              while (1) {
                switch ((_context2.prev = _context2.next)) {
                  case 0:
                    _context2.prev = 0;
                    mobilePhoneNumber = $("#mobile-nr").val();
                    _context2.next = 4;
                    return zlick.sendPinCodeSMS({
                      token: ZLICK_CONF.token,
                      mobilePhoneNumber: mobilePhoneNumber,
                    });

                  case 4:
                    response = _context2.sent;

                    challengeId = response.challengeId;
                    //$('#zlick-mobile-nr-form').css("display", "none");
                    $("#zlick-confirmation-code-form").removeClass("hidden");
                    $("#sms-auth-btn").addClass("hidden");
                    if (!$(".zlick-error-msg").hasClass("hidden")) {
                      $(".zlick-error-msg").addClass("hidden");
                    }
                    _context2.next = 14;
                    break;

                  case 11:
                    _context2.prev = 11;
                    _context2.t0 = _context2["catch"](0);

                    if (
                      _context2.t0.statusCode == 400 ||
                      _context2.t0.statusCode == 403 ||
                      _context2.t0.statusCode == 422
                    ) {
                      displayErrorMsg(getTranslation(400));
                    } else if (_context2.t0.statusCode == 412) {
                      displayErrorMsg(getTranslation(412));
                    } else if (_context2.t0.statusCode == 429) {
                      displayErrorMsg(getTranslation(429));
                    } else {
                      displayErrorMsg(getTranslation(500));
                    }

                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }
            },
            _callee2,
            this,
            [[0, 11]]
          );
        })
      );

      return function sendPinCodeSMS() {
        return _ref2.apply(this, arguments);
      };
    })();

    /* Zlick function to handle verifying pin code */

    var verifyPinCode = (function () {
      var _ref3 = _asyncToGenerator(
        /*#__PURE__*/ regeneratorRuntime.mark(function _callee3() {
          var confirmationCode, authCompleteResponse;
          return regeneratorRuntime.wrap(
            function _callee3$(_context3) {
              while (1) {
                switch ((_context3.prev = _context3.next)) {
                  case 0:
                    _context3.prev = 0;
                    confirmationCode = $("#confirmation-code").val();
                    _context3.next = 4;
                    return zlick.verifyPinCode({
                      token: ZLICK_CONF.token,
                      confirmationCode: confirmationCode,
                      challengeId: challengeId,
                    });

                  case 4:
                    authCompleteResponse = _context3.sent;

                    console.log(authCompleteResponse);
                    userId = authCompleteResponse.userId;
                    makePurchase();
                    if (!$(".zlick-error-msg").hasClass("hidden")) {
                      $(".zlick-error-msg").addClass("hidden");
                    }

                    _context3.next = 14;
                    break;

                  case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3["catch"](0);

                    if (_context3.t0.statusCode == 500) {
                      displayErrorMsg(getTranslation(500));
                    } else if (_context3.t0.statusCode == 429) {
                      displayErrorMsg(getTranslation(429));
                    } else {
                      displayErrorMsg(getTranslation(403));
                    }

                  case 14:
                  case "end":
                    return _context3.stop();
                }
              }
            },
            _callee3,
            this,
            [[0, 11]]
          );
        })
      );

      return function verifyPinCode() {
        return _ref3.apply(this, arguments);
      };
    })();

    /* Zlick function to make the purchase */

    var makePurchase = (function () {
      var _ref4 = _asyncToGenerator(
        /*#__PURE__*/ regeneratorRuntime.mark(function _callee4() {
          var response;
          return regeneratorRuntime.wrap(
            function _callee4$(_context4) {
              while (1) {
                switch ((_context4.prev = _context4.next)) {
                  case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return zlick.purchase({
                      token: ZLICK_CONF.token,
                      userId: userId,
                    });

                  case 3:
                    response = _context4.sent;

                    transactionId = response.transactionId;
                    if (response.hasAccessRights) {
                      console.log("purchase made");
                      showPurchaseMadeText(donationAmount);
                    } else if (
                      !response.hasAccessRights &&
                      response.allowedMethods.smsAuth
                    ) {
                      console.log(response, "else if");
                    }

                    _context4.next = 11;
                    break;

                  case 8:
                    _context4.prev = 8;
                    _context4.t0 = _context4["catch"](0);

                    displayErrorMsg(getTranslation("paymentError"));

                  case 11:
                  case "end":
                    return _context4.stop();
                }
              }
            },
            _callee4,
            this,
            [[0, 8]]
          );
        })
      );

      return function makePurchase() {
        return _ref4.apply(this, arguments);
      };
    })();

    /* Function to return jwt token containing the payload */

    // init necessary variables
    var ZLICK_CONF = void 0;
    var challengeId = void 0,
      userId = void 0,
      transactionId = void 0;
    var contentId = void 0;
    var donationAmount = void 0;
    var d = new Date();
    var unixTimestamp = d.getTime();

    // Create an object w translations
    var translations = {
      en: {
        400: "Phone number not supported",
        403: "Wrong PIN",
        422: "Un-Processable Entity",
        412: "Carrier not detected or supported",
        429: "Too many attempts",
        500: "Server error",
        afterPurchase:
          "Thank you for the donation! We added to your mobile phone invoice",
        paymentError: "An error occurred during the payment",
      },
      et: {
        400: "Telefoninumber ei ole korrektne.",
        403: "Vale PIN kood.",
        422: "Töötlematu üksus.",
        412: "Mobiilside teenusepakkujat ei tuvastatud või see pole toetatud",
        429: "Liiga palju katseid",
        500: "Serveri viga",
        afterPurchase:
          "Aitäh annetuse eest! Lisasime sinu mobiiltelefoni arvele",
        paymentError: "Maksmisel tekkis viga",
      },
      ru: {
        400: "Некорректный номер телефона",
        403: "Неправильный PIN-код",
        422: "Un-Processable Entity",
        412: "Оператор мобильной связи не обнаружен, или не поддерживается",
        429: "Слишком много попыток",
        500: "Ошибка сервера",
        afterPurchase: "Спасибо за пожертвование! К счету за телефон добавлено",
        paymentError: "При оплате возникла ошибка",
      },
    };

    $(window).on("load", function () {
      // get initial jwt token
      $.post(
        "https://anneta.kingitudelu.ee/zlick/token.php",
        {
          zlick_price: 100,
          contentID: unixTimestamp,
        },
        function (data, status) {
          var jwt = data;
          ZLICK_CONF = {
            selectors: {
              paymentBtn: "#zlick-payment-btn-v2",
            },
            zeroClickDisabled: true,
            language: window.zlickLanguage,
            token: jwt,
            amountLimit: 499,
          };
          initZlick(ZLICK_CONF.token);
        }
      );

      // Amount buttons
      $(".js-amount-btn").on("click", function (e) {
        e.preventDefault();
        var amount = $(this).attr("data-amount");
        $("#zlick_incoming_price").val(amount);
        $("#zlick_incoming_price").trigger("change");
      });

      // Overview
      $("#zlick_incoming_price").on("change keyup", function () {
        $(".js-donate-sum").text($(this).val());
      });
      $("#mobile-nr").on("change keyup", function () {
        if ($(this).val().trim().length == 0) {
          $(".js-donate-mobile").text("-");
        }
        $(".js-donate-mobile").text("+372 " + $(this).val());
      });

      var input = $("#zlick_incoming_price");
      // TODO: PROBLEM - input change is not triggered when the amount is entered via the clickable amount btn
      input.on("change click keyup input paste", function () {
        handleDonationSumInput(input.val());
      });

      // Donate btn
      /*$('.payment-btn').on('click', function (e) {
            e.preventDefault();
            handleDonateBtn(input.val(), e);
        });*/

      $("#sms-auth-btn").on("click", function (e) {
        handleDonateBtn(input.val(), e, () => {
          sendPinCodeSMS();
        });
      });

      $("#sms-code-auth-btn").on("click", function () {
        verifyPinCode();
      });

      /* Handle form submissions when clicking 'Enter' */
      // Prevent form from submitting when user presses enter
      $("#zlick-confirmation-code-form").on("submit", function (e) {
        e.preventDefault();
        verifyPinCode();
      });
      /*$('#zlick-mobile-nr-form').on('submit', function (e) {
            e.preventDefault();
            sendPinCodeSMS();
        });*/
      /*$('#zlick-donation-amount-form').on('submit', function (e) {
            e.preventDefault();
            handleDonateBtn(input.val(), e);
        });*/
    });

    /* Function to handle donate btn click */
    var handleDonateBtn = function handleDonateBtn(
      value,
      e,
      callback = () => {}
    ) {
      // if the amount is not in the range the btn should not do anything
      if (!isValidDonationAmount(value)) {
        e.preventDefault();
      } else {
        // save donationAmount for further usage
        donationAmount = value;
        // if user has already paid = userId is existing as a cookie
        if (userId) {
          // then make a purchase directly
          makePurchase();
          e.target.style.display = "none";
        } else {
          // else start the normal procedure
          zlickSendPrice(value, callback); // get correct jwt token
          /*$('#zlick-mobile-nr-form').css("display", "block");
                e.target.style.display = "none";*/
        }
      }
    };

    /* Function to handle donation sum input field change */
    var handleDonationSumInput = function handleDonationSumInput(value) {
      if (isValidDonationAmount(value)) {
        /*$('.payment-btn').removeClass('zlick-inactive');*/
      } else {
        /*if (!$('.payment-btn').hasClass('zlick-inactive')) {
                $('.payment-btn').addClass('zlick-inactive');
            }*/
      }
    };

    /* Function to check if donation amount is valid */
    var isValidDonationAmount = function isValidDonationAmount(value) {
      return value > 0 && value < 50;
    };

    /* Function to display error msg */
    var displayErrorMsg = function displayErrorMsg(msg) {
      var errorContainer = $(".zlick-error-msg");
      errorContainer.first().html(msg);
      errorContainer.removeClass("hidden");
    };

    /* Function to show the msg after succesful donation */
    var showPurchaseMadeText = function showPurchaseMadeText(amount) {
      var purchaseMadeTextContainer = $("#zlick-payment-options");
      purchaseMadeTextContainer
        .children()
        .first()
        .html(getTranslation("afterPurchase") + " " + amount + "€");
      purchaseMadeTextContainer.removeClass("hidden");
      $("#zlick-confirmation-code-form").addClass("hidden");
    };

    /* Function to return error msg given the error code from the translations object */
    var getTranslation = function getTranslation(key) {
      var lang = $("html").attr("lang");
      return translations[lang][key];
    };
    function zlickSendPrice(value, callback = () => {}) {
      value = value * 100;
      if (value > 0 && value < 5000) {
        console.log(value);
        $.post(
          "https://anneta.kingitudelu.ee/zlick/token.php",
          {
            zlick_price: value,
            contentID: window.unixTimestamp,
          },
          function (data, status) {
            var jwt = data;
            console.log(data);
            ZLICK_CONF = {
              selectors: {
                paymentBtn: "#zlick-payment-btn-v2",
              },
              zeroClickDisabled: true,
              language: window.zlickLanguage,
              token: jwt,
              amountLimit: 499,
            };
            callback();
          }
        );
      }
    }
  })(jQuery);
}
